import type { LabelGroups } from '../util';

import { css } from 'react-strict-dom';
import { Api } from 'src/api';
import { Stack } from 'src/components';
import { useAuthUser } from 'src/hooks';
import { isAgency } from 'src/reducers/auth';

import LabelsCard from './LabelsCard';
import MembersCard from './MembersCard';
import PullRequestsCard from './PullRequestsCard';
import SkillsCard from './SkillsCard';
import TimeTrackingCard from './TimeTrackingCard';

type Props = {
  ticket: Api.Ticket.V_Detail;
  company: Api.Company.BaseView;
  invalidate: () => void;
  agencyUsers: ReadonlyArray<Api.User.BaseView>;
  labelGroups: LabelGroups;
  style?: css.StyleXStyles | false;
};

export default function TicketActionsCards({
  ticket,
  company,
  invalidate,
  agencyUsers,
  labelGroups,
  style,
}: Props) {
  const authUser = useAuthUser();
  const showInternal = isAgency(authUser);

  return (
    <Stack gap={1.5} style={[styles.container, style]}>
      {showInternal && (
        <>
          <TimeTrackingCard
            ticket={ticket}
            company={company}
            invalidate={invalidate}
          />
          <SkillsCard
            ticketId={ticket.id}
            skills={ticket.skills}
            agencyUsers={agencyUsers}
            invalidate={invalidate}
          />
        </>
      )}
      <MembersCard memberUsers={ticket.memberUsers} />
      <LabelsCard
        ticket={ticket}
        labelGroups={labelGroups}
        invalidate={invalidate}
      />
      {showInternal && <PullRequestsCard pullRequests={ticket.pullRequests} />}
    </Stack>
  );
}

const styles = css.create({
  container: {
    width: {
      default: 350,
      '@media (max-width: 1199px)': '100%',
    },
  },
});
